import axios from 'axios'
import { arrayBufferToBlob } from 'blob-util'
import { saveAs } from 'file-saver'
import contentMixin from '@/components/helpers/mixins/content-mixin'

/* eslint-disable no-param-reassign */


export default {
  getCoursesList(perPage, pageNumber, filters, sorting) {
    const query = {
      params: {
        perPage,
        pageNumber,
        filters,
        sorting
      }
    }
    return axios.get('/api/education/courses', query)
  },
  addCourse() {
    return axios.post('/api/education/courses')
  },
  getCourseContent(id, all = false) {
    return axios.get(`/api/education/courses/${id}/content`, {
      params: { all }
    })
  },
  deleteCourse(id) {
    return axios.delete(`/api/education/courses/${id}`)
  },

  deleteCourseTopic(courseId, topicId) {
    return axios.delete(`/api/education/courses/${courseId}/content/topics/${topicId}`)
  },
  deleteCourseSection(courseId, sectionId) {
    return axios.delete(`/api/education/courses/${courseId}/content/sections/${sectionId}`)
  },
  deleteCourseSubSection(courseId, subSectionId) {
    return axios.delete(`/api/education/courses/${courseId}/content/subsections/${subSectionId}`)
  },
  setCoursePositions(courseContent) {
    courseContent.topics.forEach((topic, index) => {
      topic.position = index // eslint-disable-line no-param-reassign
      topic.sections.forEach((section, sectionIndex) => {
        section.position = sectionIndex // eslint-disable-line no-param-reassign
        // т.к. разделы с тестами могут быть пустыми
        if (section.subSections) {
          section.subSections.forEach((subSection, subSectionIndex) => {
            subSection.position = subSectionIndex // eslint-disable-line no-param-reassign
          })
        }
      })
    })
  },
  getSubsectionOfCourse(courseId, id, hashId) {
    const params = hashId !== null ? { h: hashId } : {}
    return axios.get(`/api/education/courses/${courseId}/content/subsections/${id}`, { params })
  },
  updateCourseInfo(id, courseContent) {
    return axios.put(`/api/education/courses/${id}`, {
      title: courseContent.title,
      shortInfo: courseContent.shortDescription,
      avatar: courseContent.avatar
    })
  },
  updateCourseSubsection(courseId, subSection) {
    if (subSection.position !== undefined) {
      delete subSection.position
    }
    if (subSection.file) {
      subSection.fileId = subSection.file.id
    } else {
      subSection.fileId = null
    }
    return new Promise((resolve) => {
      contentMixin.methods
        .$_contentMixin_uploadImages(subSection.text).then((res) => axios
          .put(`/api/education/courses/${courseId}/content/subsections/${subSection.id}`,
            { ...subSection, text: res }).then((response) => {
            resolve(response)
          }))
    })
  },
  updateCourseContent(id, courseContent) {
    if (courseContent[courseContent.length - 1].title === 'Тестирование') {
      courseContent.pop()
    }
    return axios.put(`/api/education/courses/${id}/content`, courseContent)
  },
  // получить список приглашенных на курс
  // получить прогресс учеников по курсу
  getCourseStudentsProgress(courseId, classes, organizationId) {
    const params = {
      classes
    }
    if (organizationId) {
      params.organizationId = organizationId
    }
    return axios.get(`/api/education/courses/${courseId}/students/report`, { params })
  },
  sendCourseInvitations(courseId, students) {
    return axios.post(`/api/education/courses/${courseId}/students`, { students })
  },
  checkAnswerOnQuestion(courseId, subsectionId, answer) {
    return axios.put(`/api/education/courses/${courseId}/content/subsections/${subsectionId}/progress`, { answer })
  },
  getCourseProject(courseId) {
    return axios.get(`/api/education/courses/${courseId}/progress`)
  },
  applyOnCourse(courseId) {
    return axios.post(`/api/education/courses/${courseId}/start`)
  },
  getMarksForTests(courseId) {
    return axios.get(`/api/education/courses/${courseId}/tests/progress`)
  },
  exportStudentProgressExcel(courseId, classes, organizationId) {
    const query = {
      responseType: 'arraybuffer',
      params: {
        classes
      }
    }
    if (organizationId) {
      query.params.organizationId = organizationId
    }
    return axios.get(`/api/education/courses/${courseId}/students/report/xlsx`, query)
      .then(
        (response) => {
          saveAs(arrayBufferToBlob(response.data),
            response.headers['content-disposition']
              .replace('attachment; filename=', ''))
        },
        (error) => {
          console.log(error)
        },
      )
  }
}
